import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchOnlineResource } from '@/reducers/asset/asyncActions'
import {
  isCoursewareWebsiteSelector,
  isRequestingOnlineResourceSelector,
  isShowingBookshelfLoginLinkSelector
} from '@/selectors'
import { routeFor } from '@/utils/router'

import BookshelfLoginLink from './components/BookshelfLoginLink'
import CoursewareLoginLink from './components/CoursewareLoginLink'

const API_ASSETS_ONLINE_RESOURCE = 'apiAssetsOnlineResource'

const CoursewareInformation = () => {
  const dispatch = useDispatch()

  const id = useSelector(state => state.asset.id)

  const isRequestingOnlineResource = useSelector(
    isRequestingOnlineResourceSelector
  )

  const isShowingCoursewareWebsite = useSelector(isCoursewareWebsiteSelector)

  const isShowingBookshelfLoginLink = useSelector(
    isShowingBookshelfLoginLinkSelector
  )

  useEffect(() => {
    if (isRequestingOnlineResource) {
      dispatch(fetchOnlineResource({
        path: routeFor(API_ASSETS_ONLINE_RESOURCE, id)
      }))
    }
  }, [])

  return (
    <If condition={isShowingCoursewareWebsite}>
      <Choose>
        <When condition={isShowingBookshelfLoginLink}>
          <BookshelfLoginLink />
        </When>
        <Otherwise>
          <CoursewareLoginLink />
        </Otherwise>
      </Choose>
    </If>
  )
}

export default CoursewareInformation
